import React, { useState, useEffect, memo } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import axios from "axios";
import $ from 'jquery';
import './panel.css';
import frm from './formAux.js'

var descriptor = {};
var origDescriptor = null;

var availModels = {};
var awsCreds = [];


function px(v) { return v + 'px'; }
function pc(v) { if (v < 0) v = 0; if (v > 100) v = 100; return Math.round(v) + '%'; }
function val(v) { v = parseFloat(v); if (isNaN(v)) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring(o) { return typeof (o) == 'string'; }
function isarray(o) { return o instanceof Array; }
function isobj(o) { return o instanceof Object; }
function isnumber(o) { return typeof (o) == 'number' && !isNaN(o); }
function defined(o) { return typeof (o) != 'undefined'; }
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec() { return new Date().getTime(); }
function getsec() { return Math.round(getmsec() / 1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig, '').toLowerCase() }
function iarray(v, n) {
    var ret = [];
    for (var i = 0; i < n; i++)
        ret.push(v instanceof Object ? clone(v) : v);
    return ret;
}

function exists(o) {
    if (!o) return false;
    if (!isobj(o)) return false;
    return Object.keys(o).length > 0;
}


var modelLabels = {};

function awsTypeChange() {
    var type = $('#awstype').val();
    $('.awstyperole').hide();
    $('.awstypekey').hide();
    if (type == 'role') $('.awstyperole').show();
    if (type == 'key') $('.awstypekey').show();
}


function setDescriptor( bool )
{
	for( var k in bool )
	{
		descriptor[k] = bool[k];
	}
}

var currentDatasetId = null;
var currentDataset = {};
var currentMode = 0;

var datasetVisible = true;
var datasetDelete = false;

var saveNextPage = 'datasetItems';

var ocrModels = null;
var selectedOcrModel = null;

function DatasetSetup(prop) {
    var projects = {};
    var pdfs = [];
    var keepDocs = false;
    var global = window.GlobalVars;

    function saveDataset(callback) {
        frm.removeInlineErrors() // added 19/1 mani
        var payload = {};
        payload.delete = datasetDelete;

        payload.datasetName = $('#datasetname').val().trim();
        if( !payload.datasetName ) 
        return frm.inlineError($('#datasetname'),'Please type a name for the dataset')// added 19/1 mani
        // return error( 'Please type a name for the dataset', $('#datasetname') )
        payload.datasetDescription = $('#datasetdescription').val();
        payload.datasetType = $('#datasettype').val();

        if( frm.requiredInputs() ) return;

        if( currentDataset.ocrExtractModel ) {
            payload.ocrExtractModel = currentDataset.ocrExtractModel
        }
        if( datasetDelete ) payload.active = false;
        if( descriptor.hasAWSCredentials ) {
            payload.descriptor = currentDataset.descriptor;
            payload.awsCredentials = currentDataset.awsCredentials;
            // let awsType = $('#awstype').val() || 'global';
            // if( !awsType )   return frm.inlineError($('#awstype'),'Select the AWS Credential type')
            // // return frm.myAlert( 'Save Dataset', 'Select the AWS Credential type')
            // descriptor.awsCredentials = {
			// 	awsType: awsType.trim(),
			// 	awsRoleArn: $('#awsrolearn').val().trim(),
			// 	awsExternalId: $('#awsexternalid').val().trim(),
			// 	awsKey: $('#awskey').val().trim(),
			// 	awsSecret: $('#awssecret').val().trim(),
			// 	awsRegion: $('#awsregion').val().trim(),
			// }
            // payload.descriptor = clone(descriptor)
            // for( var k in payload.descriptor.awsCredentials ) {
            //     if( payload.descriptor.awsCredentials[k].match(/\*\*\*/) ) {
            //         delete payload.descriptor.awsCredentials[k];
            //     }
            // }
            // payload.descriptor.s3IntermediateUrl = $('#awsintermediatepath').val().trim();

			// if( descriptor.awsCredentials.awsType == 'key') {
			// 	if( !descriptor.awsCredentials.awsKey ) return frm.inlineError($('#awskey'),'You must set the AWS Access Key')// added 19/1 mani
            //     // return frm.myAlert( 'Save Dataset', 'You must set the AWS Access Key', 'Ok', function(){ $('#awskey')[0].focus()} );
			// 	if( !descriptor.awsCredentials.awsSecret ) return frm.inlineError($('#awssecret'),'You must set the AWS Secret')// added 19/1 mani
            //     //  return frm.myAlert( 'Save Dataset', 'You must set the AWS Secret', 'Ok', function(){ $('#awssecret')[0].focus()} );
			// 	if( !descriptor.awsCredentials.awsRegion ) return frm.inlineError($('#awsregion'),'You must set the AWS region')// added 19/1 mani
            //     //  return frm.myAlert( 'Save Dataset', 'You must set the AWS region', 'Ok', function(){ $('#awsregion')[0].focus()} );
			// }
			// else if( descriptor.awsCredentials.awsType == 'role') {
			// 	if( !descriptor.awsCredentials.awsRoleArn ) return frm.inlineError($('#awsrolearn'),'You must set the AWS Role ARN')// added 19/1 mani
            //     // return frm.myAlert( 'Save Dataset', 'You must set the AWS Role ARN', 'Ok', function(){ $('#awsrolearn')[0].focus()} );
			// 	if( !descriptor.awsCredentials.awsExternalId ) return frm.inlineError($('#awsexternalid'),'You must set the AWS External Id')// added 19/1 mani
            //     // return frm.myAlert( 'Save Dataset', 'You must set the AWS External Id', 'Ok', function(){ $('#awsexternalid')[0].focus()} );
			// }
			// if( !payload.descriptor.s3IntermediateUrl )return frm.inlineError($('#awsintermediatepath'),'You must select a intermediate bucket path')// added 19/1 mani
            // //  return frm.myAlert( 'Save Dataset', 'You Must select a intermediate bucket path', 'Ok', function(){ $('#awsintermediatepath')[0].focus()} );
            // // if( !payload.descriptor.s3IntermediateUrl.length ) return error( 'S3 Intermediate path is required if using AWS credentials.', $('#awsintermediatepath') )
        } else {
            payload.descriptor = {hasAWSCredentials: false, s3IntermediateUrl: ''};
        }
        payload.metadata = currentDataset.metadata;
        
        for( let e of ['enableEmbeddingsModel','embeddingModel','embeddingModelId', 'openAIKey'] ) {
            if( e in currentDataset ) payload[e] = currentDataset[e];
        }



        var cmd = 'update_dataset';
        console.log( cmd, payload )
        // return;
        if (currentDatasetId) {
            delete payload.datasetType;
            payload.datasetId = currentDatasetId;
            frm.loading('Saving Dataset');
            console.log('pay dat', JSON.stringify(payload))
            // alert(1)
            window.post('update_dataset', {dataset:payload}, async res => {
                if( !frm.resultCheck(res)) return (datasetDelete = false);
                frm.loadingOut();
                var data = res.data;
                console.log( 'RESDATA', data, isstring(data) )
                if( isstring(data) ) return error( data );
                if( !data.status ) return error( data.value );
                global.currentDataset = data;
                var {data} = await window.post('find_datasets', {match:{datasetId:payload.datasetId}})
                if( data.records && data.records.length ) {
                    global.currentDataset = data.records[0]
                    global.currentDatasetId = global.currentDataset.datasetId;
                }
                window.saveSession( function() {
                    if( callback ) callback();
                })
            })
        } else {
            console.log( 'add_dataset', JSON.stringify(payload) );
            payload.active = true;
            frm.loading('Saving Dataset');
            window.post('add_dataset', {dataset:payload}, async res => {
                frm.loadingOut();
                var data = res.data;
                if( isstring(data) ) return error( data );

                console.log( 'add_dataset', payload, 'res', res );
                // global.currentDatasetId = data.datasetId;
                // global.currentDataset = data;
                saveNextPage = 'datasetUpload';
                var {data} = await window.post('find_datasets', {match:{datasetId:data.datasetId}})
                global.currentDataset = data.records[0]
                global.currentDatasetId = global.currentDataset.datasetId;
                window.saveSession( function() {
                    if( callback ) callback();
                })
            })
        }

        function error( m, focusElement ) {
            function errFunc(){
                frm.myAlert( 'Invalid data', m, 'Ok', function(){
                    frm.myAlertClose( function(){
                        if( focusElement && $(focusElement).length ) $(focusElement)[0].focus();
                    });
                } );
            }
            if( $('#myModal').is(':visible') ) {
                frm.myAlertClose( errFunc );
            }
            else errFunc();
        }
    }

    function wizzuttons() {
        if (1) {
            window.wizzardBar(true)
            $('.wizzbtn').html('<button id="cancelbtn" class="btn btn-secondary mr-2"><i class="fa fa-times-circle mr-2" aria-hidden="true"></i> Cancel</button><button id="savebtn" class="btn btn-pink mt-0"><i class=" mr-2 fa fa-floppy-o"></i>Save</button><button id="deletebtn" class="btn btn-danger ml-2"><i class="fa fa-trash-o mr-2"></i> Delete</button>');
            $('#cancelbtn').on('click', function () {
                window.goPage('datasets');
            })
            $('#savebtn').on('click', function () {
                let datasetName = $('#datasetname').val();
                if(!datasetName){
                    $('#warnings').removeClass('hidden').addClass('block');
                }
                saveDataset(function () {
                    window.goPage(saveNextPage);
                })
            })
            $('#deletebtn').on('click', async function () {
                let confDel = await frm.myConfirm('Delete Dataset', 'Do you really want to delete this Dataset?<br><b>This action cannot be undone.</b>', 'delete', 'Delete dataset ', 'Cancel')
                if( confDel ) {
                    datasetVisible = false;
                    datasetDelete = true;
                    saveDataset(function () {
                        window.GlobalVars.currentDataset = null;
                        window.GlobalVars.currentDatasetId = null;
                        setTimeout( function(){
                            window.saveSession(function () {
                                window.goPage('datasets')
                            })
                        }, 100 )
                    })
                }
            })
            if( !currentDatasetId ) $('#deletebtn').hide();
            window.topBarVisible()
            return;
        }
        // var save = currentMode == 2 ? saveDatasetVisible : saveDataset;
        // window.wizzardButtons( $('.wizzbtn'), save )
    }
	function bval( v ) { return v || false }

    function ocrOptions() {
        // console.log('VVVV',  $('#datasettype').val() )
        if( $('#datasettype').val() != 'PDFOCR' ) {
            $('.ocr-options-panel').hide();
            return;
        }
        
        if( !ocrModels ) {
            ocrModels = true;
            let models = [{value:'awstextract',label:'AWS Textract (default)'}];
            window.post('find_models', {match:{type:'ocr_extractor'}}, res => {
                ocrModels = res.data.records;
                console.log( 'MODELS', ocrModels )
                for( let m of ocrModels ) {
                    models.push( {value:m.id, label: m.name});
                    $('#ocrmodel').html('')
                }
                console.log( 'currentDataset.ocrExtractModel', currentDataset.ocrExtractModel)
                console.log( 'modelsopt', models )
                frm.dropDown($('#ocrmodel'), models, currentDataset.ocrExtractModel || 'awstextract', {placeholder:'Select OCR Model', width: 450}, function(v){
                    if( v == descriptor.ocrExtractModel ) return;
                    currentDataset.ocrExtractModel = descriptor.ocrExtractModel = v;
                } ).addClass('imgcls-dropdown-setup');
            });
        }
        
        $('.ocr-options-panel').show();
		// var textractItems = {
		// 	'useTablemodel': { default: false, label: 'Extract Tables using Amazon Textract' },
		// 	'useKeypairmodel': { default: false, label: 'Extract Key value pairs using Amazon Textract' },
		// }
		// frm.booleanList($('.ocr-options'), descriptor, {
		// 	items: textractItems,
		// 	callbackOnInit: true,
		// }, function (o) {
        //     for( let i in o ) descriptor[i] = o[i];
		// });
	}

    async function initDataset() {
        if (global.currentDatasetId) {
            $('#datasetid').html('ID: ' + global.currentDatasetId + '<br>')
            currentDatasetId = global.currentDatasetId;
            currentDataset = global.currentDataset;
            $('#datasettype').attr( 'disabled',true);
        }
        if (!currentDataset.descriptor) currentDataset.descriptor = {};
        descriptor = currentDataset.descriptor;
        if (!descriptor.awsCredentials) descriptor.awsCredentials = {};
        if (descriptor.awsCredentials.awsType) descriptor.hasAWSCredentials = true;

        window.descriptor = descriptor;

        $('#datasetname').val(currentDataset.datasetName);
        $('#datasetdescription').val(currentDataset.datasetDescription);
        $('#datasettype').val(currentDataset.datasetType || 'Image');
        $('#datasettype').off('change').on('change', function(){
            ocrOptions();
            currentDataset.datasetType = $('#datasettype').val();
            formOptions();
            // alert( currentDataset.datasetType )
        })
        ocrOptions();
        frm.booleanList($('.project-aws-bool'), descriptor, {
            items: {
                'hasAWSCredentials': { default: false, label: 'Enable AWS Credentials' },
            },
            callbackOnInit: true,
        }, function (o) {
            setDescriptor(o)
            setTimeout(function () {
                $('.project-aws-panel')[o.hasAWSCredentials ? 'show' : 'hide']();
                $('#awstype').off('change').on('change', awsTypeChange)
                awsTypeChange();
            }, 1);
        });


        $('#awstype').val(descriptor.awsCredentials.awsType).off('change').on('change', awsTypeChange)
        $('#awsrolearn').val(descriptor.awsCredentials.awsRoleArn)
        $('#awsexternalid').val(descriptor.awsCredentials.awsExternalId)
        // $('#awsrolesessionname').val(descriptor.awsCredentials.awsRoleSessionName)

        $('#awskey').val(descriptor.awsCredentials.awsKey)
        $('#awssecret').val(descriptor.awsCredentials.awsSecret)
        $('#awsregion').val(descriptor.awsCredentials.awsRegion)
        // $('#awsintermediatepath').val(descriptor.s3IntermediateUrl)
        $('#awsintermediatepath').val(descriptor.s3IntermediateUrl);


        $('#awstype').off('change').on('change', awsTypeChange)
        awsTypeChange();

        async function formOptions(){

            frm.optionList($('.dataset-metadata'), frm.vals2Obj(currentDataset.metadata, 'value'), {
                fields: {
                    'label': { type: 'text', placeholder: 'Enter label', label: 'Label' },
                    'value': { type: 'text', placeholder: 'Enter value', label: 'Value' },
                },
                defaultField: 'value',
                subLabels: false, 
                maxSubLabels: 0,
                callbackOnInit: true,
            }, function (o) {
                currentDataset.metadata = frm.obj2Vals(o, 'value');
            });
            
            $('.panel2').html('')
            if( window.isDev ) {
                
                let mtype = {
                    "Image": "image_embeddings",
                    "PDF": "text_embeddings",
                    "Text": "text_embeddings",
                    "PDFOCR": "text_embeddings",
                    "Video": "video_embeddings",
                    "Audio": "audio_embeddings",
                    "Csv": "classification_prompt"
                }
        
        
                let embeddingModels = (await window.post('find_models', { match:{type: mtype[$('#datasettype').val()] }})).data.records.map( v => ({value:v.id,label:v.name}))
                console.log('emb', embeddingModels)
                console.log( 'EEEEEEEEEEEEEEEEEEEE', $('#datasettype').val(), mtype[$('#datasettype').val()], embeddingModels )
        
                // alert( 'e')
                let embeddings = [
                    {
                        "key": "enableEmbeddingsModel",
                        "label": "Enable Embeddings Model",
                        "type": "boolean",
                        "default": false,
                        "subFields": [
                            {
                                "title": "Embeddings Model",
                                "key": "embeddingModelId",
                                "type": "dropdown",
                                "placeholder": "Select embeddings model",
                                "options": embeddingModels
                            }
                        ]
                    }
                ]
                $('.panel2').html('')
                if( embeddingModels.length || currentDataset.embeddingModelId ) {
                    let nc = frm.configSection( $('.panel2'), 'Embeddings Model', true );
                    frm.configOptions(nc, embeddings, currentDataset);
                }
            }
            let awsc = frm.configSection( $('.panel2'), 'AWS Credentials', true );
            let ac = [
                {
                    "key": "descriptor.hasAWSCredentials",
                    "label": "Enable AWS Credentials",
                    "type": "boolean",
                    "default": false,
                    "subFields": awsCreds,
                }
            ]
            frm.configOptions(awsc, ac, currentDataset);
        }

        formOptions();

        wizzuttons();
    }

    $(function () {
        var loc = window.location.href; // returns the full URL
        if (/#Project%20Labels%20&%20Relationships/.test(loc)) {
            $('.wizzbtn').addClass('last_step_btns');
        }
    });

    useEffect( async function (a) {
        $('#datasettype').html('');
        for( let t in window.DatasetTypes ) {
            $('#datasettype').append( $('<option>').val(t).html(window.DatasetTypes[t]) )
        }
        awsCreds = (await window.post('get_aws_credentials_options_list', {
            intermediate:"descriptor.s3IntermediateUrl",
            type: "awsCredentials.awsType",
            key: "awsCredentials.awsKey",
            secret: "awsCredentials.awsSecret",
            region: "awsCredentials.awsRegion",
            role: "awsCredentials.awsRoleArn",
            extid: "awsCredentials.awsExternalId",
        })).data;
        console.log( 'AWSCREDS', awsCreds )
        // $('#awstype').html(awsCreds)
		frm.convertSelects($('select'));
        initDataset();
    });

    return (
        <div fluid="md p-0" className="maincontent">
            <div className="project-panel">
                <div className="step1">
                    <div className="project-section project-aws">
                    <button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseTwenty-Two" aria-expanded="true" aria-controls="collapseTwenty-Two">
                    <h1>Dataset Setup</h1><i className="fa fa-chevron-down acc"></i></button>
					<div id="collapseTwenty-Two" className="collapse show projectid" aria-labelledby="headingTwenty-Two" > 
                        <div id="datasetid" className="project-id"></div>
                        {/* <p class="hidden" id="warnings" style={{color: "red"}}>Please fill required fields</p> */}
                        <label htmlFor="datasetname">Dataset Name *</label>
                        <input placeholder="Dataset Name" type="text" id="datasetname" className="mb-4 form-control" />
                        <label htmlFor="datasetdescription">Dataset Description</label>
                        <input placeholder="Description" type="text" id="datasetdescription" className="mb-4 form-control" />
                        <label htmlFor="datasettype">Dataset Type *</label>
                        <select placeholder="Dataset Type" type="text" id="datasettype" className="mb-4 form-control">
                            <option value="Image">Image</option>
                            <option value="PDF">PDF</option>
                            <option value="PDFImage">Scanned Text Document</option>
                            <option value="PDFOCR">OCR Processed PDF</option>
                            <option value="Text">Plain Text Document</option>
                            <option value="Video">Video</option>
                            <option value="Audio">Audio</option>
                             <option value="Csv">Csv</option>
                        </select>
                        <div className="activeckbox hidden">
                            <input type="checkbox" id="datasetactive" /> Dataset Active
                        </div>
                    </div>
                    </div>
                </div>

                <div className="project-section ocr-options-panel">
                <button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseTwenty-Three" aria-expanded="true" aria-controls="collapseTwenty-Three">
                <h1>OCR Options</h1><i className="fa fa-chevron-down acc"></i></button>
                <label htmlFor="ocrmodel" className="">Model</label>
                <div id="ocrmodel">
                </div>
                <div className="ocr-options"></div>
                </div>

            </div>
            <div className="project-panel panel2">
            </div>
            <div className="project-panel panel3">
   

                <div className="project-section">
                <button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseTwenty-Four" aria-expanded="true" aria-controls="collapseTwenty-Four">
                <h1>Dataset Metadata</h1><i className="fa fa-chevron-down acc"></i></button>
					<div id="collapseTwenty-Four" class="collapse show" aria-labelledby="headingTwenty-Four" > 
                    <div className="dataset-metadata"></div>
                    <br></br>
                    </div>
                </div>
            </div>
            <div className="wizzbtn"></div>
        </div>
    )
}


export default DatasetSetup
